import { logger, useAuth } from '@multiplatform-apps/service-trips';
import { useEffect, useRef, useState } from 'react';

const MAX_INIT_RETRIES = 5;
const INIT_RETRY_DELAY_MS = 10_000;

export const useInitApp = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const { refreshUser } = useAuth();
  const retryCount = useRef(0);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    async function prepare() {
      try {
        await refreshUser();
      } catch (e) {
        if (retryCount.current < MAX_INIT_RETRIES) {
          retryCount.current += 1;
          // Transient failure — retry silently in the background so the app
          // transitions to authenticated state when the network recovers.
          timeoutId = setTimeout(prepare, INIT_RETRY_DELAY_MS);
        } else {
          logger.warn('App initialisation failed after max retries', e);
        }
      } finally {
        setIsInitialized(true);
      }
    }

    prepare();
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isInitialized;
};
